export const LIVE_RADIO_LIST = 'LIVE_RADIO_LIST';  // 直播课程列表
export const COURSE_TYPES = 'COURSE_TYPES';  // 课程类型列表
export const FILTER_COURSE_LIST = 'FILTER_COURSE_LIST';  // 根据课程类型课程名称模糊查询的课程列表
export const GROWTH_PLAN = 'GROWTH_PLAN';  // 用户成长计划
